
import { colors } from 'themes/variables';

export default theme => ({
  title: {
    fontSize: '500%',
    color: colors.primary,
  },
  bottom: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  forgot: {
    paddingRight: 0,
    paddingLeft: 0,
  },
  padding: {
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
  },
  middle: {
    textAlign: 'center',
  },
  light: {
    color: colors.primary,
    textDecoration: 'none',
  },
});
